<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 25H86V73H43L37.5 82L32 73H15V25Z" stroke="black" stroke-width="4"/>
<path d="M24 38H76" stroke="black" stroke-width="4"/>
<path d="M24 49H60" stroke="black" stroke-width="4"/>
<path d="M24 60H44.5" stroke="black" stroke-width="4"/>
</svg>

</template>
